import React, { Component } from "react";

class OnboardForm extends Component {
	render() {
		return "Onboard";
	}
}

export default OnboardForm;
